var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 1600,
    viewBox: "0 0 1600 1600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M838.128 1438V1111.19L877.589 1433.26C1031.84 1414.36 1173.9 1339.81 1277.08 1223.6C1380.27 1107.39 1437.49 957.51 1438 802.101C1438.51 646.693 1382.28 496.441 1279.86 379.552C1177.45 262.663 1035.89 187.176 881.758 167.26L838.128 504.925V162H761.873V492.357L681.227 171.995L607.279 190.61L696.254 544.058L514.017 228.415L447.979 266.543L622.167 568.245L375.827 321.906L321.906 375.826L568.257 622.176L266.54 447.98L228.413 514.019L530.128 688.214L193.608 598.044L173.872 671.701L510.397 761.873H162V838.127H510.393L173.871 928.298L193.608 1001.95L530.133 911.783L228.413 1085.98L266.541 1152.02L568.257 977.824L321.906 1224.17L375.826 1278.1L622.175 1031.75L447.98 1333.46L514.019 1371.59L688.214 1069.87L598.044 1406.39L671.701 1426.13L761.873 1089.6V1438H838.128ZM827.256 589.064C818.332 587.922 809.235 587.333 800.001 587.333C682.548 587.333 587.334 682.547 587.334 800C587.334 917.453 682.548 1012.67 800.001 1012.67C808.756 1012.67 817.388 1012.14 825.866 1011.11C931.119 998.348 1012.67 908.697 1012.67 800C1012.67 691.782 931.836 602.443 827.256 589.064Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7c22b954615091234aa1a1bf2d51f7fd.svg";
export { ForwardRef as ReactComponent };